import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="max-w-lg mx-auto px-6 py-28 text-center" data-testid="payment-cancel-page">
      <XCircle className="w-14 h-14 text-gold-muted/60 mx-auto" />
      <h1 className="font-serif text-3xl text-gold-light mt-6">Checkout cancelled</h1>
      <p className="text-muted-foreground mt-2">No worries — your cart is saved. Pick up where you left off.</p>
      <Link to="/collection" className="mt-8 inline-block bg-gold text-obsidian font-semibold px-6 py-3 rounded-full hover:bg-gold-light transition-colors">
        Return to collection
      </Link>
    </div>
  );
}
